(function (){
  const checkValidDeathYear = () => {
    const { value: birthVal } = document.getElementById('birthYear');
    const deathYearEl = document.getElementById('deathYear');
    const { value: deathVal } = deathYearEl;
    if (birthVal && deathVal && birthVal > deathVal) {
      deathYearEl.setCustomValidity(window.deathBeforeBirthValidation);
    } else {
      deathYearEl.setCustomValidity('');
    }
  };

  document.getElementById('birthYear').addEventListener('change', checkValidDeathYear);
  document.getElementById('deathYear').addEventListener('change', checkValidDeathYear);

  const handleFormSubmit = event => {
    const formEl = document.getElementById('discoveryForm');
    if (!formEl.checkValidity()) return;
    const { classList } = document.getElementById('submitFormBtn');
    if (classList.contains('fs-button--loading')) {
      event.preventDefault();
    } else {
      classList.add('fs-button--loading');
    }
  }

  document.getElementById('submitFormBtn').addEventListener('click', handleFormSubmit);
}());
